var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfidTurnOnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50345 1.36438C6.50345 1.08824 6.27959 0.86438 6.00345 0.86438C5.72731 0.86438 5.50345 1.08824 5.50345 1.36438V7.36438C5.50345 7.64052 5.72731 7.86438 6.00345 7.86438C6.27959 7.86438 6.50345 7.64052 6.50345 7.36438V1.36438ZM3.27739 3.88014C3.50699 3.72673 3.56876 3.41623 3.41535 3.18662C3.26194 2.95702 2.95144 2.89525 2.72183 3.04866C1.66937 3.75186 0.870966 4.7749 0.444526 5.96667C0.0180863 7.15843 -0.0137753 8.45575 0.353647 9.66702C0.721069 10.8783 1.46829 11.9393 2.48496 12.6933C3.50163 13.4473 4.73384 13.8544 5.99961 13.8544C7.26538 13.8544 8.49759 13.4473 9.51426 12.6933C10.5309 11.9393 11.2782 10.8783 11.6456 9.66702C12.013 8.45575 11.9811 7.15843 11.5547 5.96667C11.1283 4.7749 10.3298 3.75186 9.27739 3.04866C9.04778 2.89525 8.73728 2.95702 8.58387 3.18662C8.43046 3.41623 8.49223 3.72673 8.72183 3.88014C9.59591 4.46416 10.259 5.31379 10.6132 6.30357C10.9673 7.29334 10.9938 8.37078 10.6886 9.37674C10.3835 10.3827 9.76291 11.2639 8.91856 11.8901C8.0742 12.5163 7.05084 12.8544 5.99961 12.8544C4.94838 12.8544 3.92502 12.5163 3.08067 11.8901C2.23631 11.2639 1.61574 10.3827 1.31059 9.37674C1.00544 8.37078 1.0319 7.29334 1.38607 6.30357C1.74023 5.31379 2.40331 4.46416 3.27739 3.88014Z",
    fill: "#A2A2A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidTurnOnIcon);
export default __webpack_public_path__ + "static/media/bfid-turn-on-icon.9062426eda512d3c76c2c03bc96e0ecb.svg";
export { ForwardRef as ReactComponent };